var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 51,
    viewBox: "0 0 120 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#fff;}.b{fill:#fff;stroke:#000;stroke-width:1.19px;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1028 -6869.25)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1028 6869.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 60,
    cy: 25.5,
    rx: 60,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 60,
    cy: 25.5,
    rx: 59.5,
    ry: 25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1082.262 6883.155)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.929,23.61V12.532H0V8.543H2.929V5.136C2.929,2.459,4.66,0,8.647,0a24.218,24.218,0,0,1,2.808.155L11.361,3.88s-1.217-.012-2.546-.012c-1.438,0-1.668.663-1.668,1.762V8.543h4.328l-.188,3.989H7.147V23.61H2.929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c855d55c6ae30e6b0e3a48b298206c3c.svg";
export { ForwardRef as ReactComponent };